var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Checkbox } from '../Checkbox';
import { Spinner } from '../Spinner';
import { Button } from '../Button';
import classnames from 'classnames';
export const Option = (_a) => {
    var { className, collapseControl, collapsed, content, disabled, focus, indeterminate, label, level, loading, onChange, onExpand, onKeyDown, options, readOnly, secondaryAction, selected, selfObject, text, value } = _a, props = __rest(_a, ["className", "collapseControl", "collapsed", "content", "disabled", "focus", "indeterminate", "label", "level", "loading", "onChange", "onExpand", "onKeyDown", "options", "readOnly", "secondaryAction", "selected", "selfObject", "text", "value"]);
    const OptionClasses = classnames('OptionList__option', className, {
        'OptionList__option--selected': selected,
        'OptionList__option--disabled': disabled,
        'OptionList__option--read-only': readOnly || disabled,
        'OptionList__option--custom': content && typeof content !== 'string',
        'OptionList__option--text': !(content && typeof content !== 'string'),
    });
    const getCollapseButton = () => {
        if (!collapseControl)
            return;
        const arrow = collapsed
            ? 'keyboard_arrow_down'
            : 'keyboard_arrow_right';
        return (React.createElement(Button, { iconName: arrow, xsmall: true, fill: "subtle", onClick: handleOnClick, className: "OptionList__collapse" }));
    };
    const getLabel = () => {
        if (label)
            return label;
        if (content !== undefined && content !== null)
            return content;
        if (text !== undefined && text !== null)
            return text;
        return String(value);
    };
    const getLoading = () => {
        if (!loading)
            return;
        return React.createElement(Spinner, { size: "tiny", className: "OptionList__spinner" });
    };
    const getSecondaryAction = () => {
        if (secondaryAction === undefined)
            return;
        return (React.createElement("div", { className: "OptionList__option--secondary-action" }, secondaryAction));
    };
    const handleOnClick = () => {
        return onExpand(value);
    };
    const handleOnChange = () => {
        if (readOnly || onChange === undefined)
            return;
        return onChange(value, !selected, options, selfObject);
    };
    const handleOnKeyDown = (e) => {
        if (onKeyDown === undefined)
            return;
        return onKeyDown(e, selfObject);
    };
    return (React.createElement("div", Object.assign({ className: OptionClasses, "aria-level": level }, props),
        getLoading() || getCollapseButton(),
        React.createElement(Checkbox, { checked: selected, disabled: disabled, focus: focus, indeterminate: indeterminate, label: getLabel(), onChange: handleOnChange, onKeyDown: handleOnKeyDown, value: value }),
        getSecondaryAction()));
};
//# sourceMappingURL=Option.js.map